import { useLocation } from "@/lib/locationContext";
import { useNavigate } from "react-router-dom";
import { MapPin, Plus, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LocationSwitcher() {
  const { locations, activeLocation, setActiveLocationId } = useLocation();
  const navigate = useNavigate();

  if (locations.length === 0) {
    return (
      <Button size="sm" variant="outline" className="gap-1.5 text-xs" onClick={() => navigate("/my-locations")}>
        <Plus className="w-3.5 h-3.5" /> Add Location
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" variant="outline" className="gap-1.5 max-w-[180px]">
          <MapPin className="w-3.5 h-3.5 text-primary shrink-0" />
          <span className="truncate text-xs">{activeLocation?.name || "Select location"}</span>
          <ChevronDown className="w-3 h-3 text-muted-foreground shrink-0" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        {locations.map(loc => (
          <DropdownMenuItem
            key={loc.id}
            onClick={() => setActiveLocationId(loc.id)}
            className={`gap-2 ${loc.id === activeLocation?.id ? "bg-primary/5 font-medium" : ""}`}
          >
            <MapPin className={`w-3.5 h-3.5 ${loc.id === activeLocation?.id ? "text-primary" : "text-muted-foreground"}`} />
            <div className="flex-1 min-w-0">
              <p className="text-sm truncate">{loc.name}</p>
              {loc.city && <p className="text-xs text-muted-foreground">{loc.city}</p>}
            </div>
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate("/my-locations")} className="gap-2 text-primary">
          <Plus className="w-3.5 h-3.5" /> Manage Locations
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
